// In a new file: src/components/OAuthCallbackHandler.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { getCurrentUser } from 'aws-amplify/auth';


const OAuthCallbackHandler = () => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    console.log("Checking user is logged in or not");
    checkUserAuth();
    // Set up a listener for auth events
    if (!user) {
      const listener = Hub.listen('auth', ({ payload }) => {
        if (payload.event === 'signedIn') {
          // Auth completed successfully

          // Check for stored redirect URL
          const storedRedirect = localStorage.getItem('authRedirectUrl');
          if (storedRedirect) {
            localStorage.removeItem('authRedirectUrl');
            navigate(storedRedirect);
          } else {
            // Default redirect
            navigate('/trips');
          }
        }
      });
      return () => {
        listener(); // Clean up listener
      };
    } else {
      console.log("User is found, so redirecting");
      const storedRedirect = localStorage.getItem('authRedirectUrl');
          if (storedRedirect) {
            console.log("Redirecintg to:", storedRedirect);
            localStorage.removeItem('authRedirectUrl');
            navigate(storedRedirect);
          } else {
            // Default redirect
            console.log("Redirecting to trips");
            navigate('/trips');
          }
    }
  }, [navigate, user]);

  const checkUserAuth = async () => {
    try {
      const user = await getCurrentUser();
      console.log("Found logged in user: ", user);
      setUser(user);
    } catch (error) {
      throw error;
    }
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Logging in...</h2>

    </div>
  );
};

export default OAuthCallbackHandler;